const ORDER_SUFFIX = /\.\d*$/;

const getParentOrder = (order) =>
  order.split('.').length > 1 ? order.replace(ORDER_SUFFIX, '') : null;

export default getParentOrder;
